import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { EqualValidator } from 'src/app/shared/validators/equal-validator.directive';
import { AuthService } from 'src/app/auth/services/auth.service';
import { ProfileService, IProfile } from 'src/app/account/services/profile.service';
import { finalize } from 'rxjs/operators';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { ValidatorsService } from 'src/app/shared/services/validators.service';

export interface ICheckoutPersonalInfoForm {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  _valid: boolean;
}

@Component({
    selector: 'store-checkout-personal-info-form',
    templateUrl: './checkout-personal-info-form.component.html',
    styleUrls: ['./checkout-personal-info-form.component.scss'],
    standalone: false
})
export class CheckoutPersonalInfoFormComponent implements OnInit {
  form: FormGroup;
  formErrors: Map<string, string> = new Map<string, string>();
  profile: IProfile;

  patternReference: any = {};

  private _submitted: boolean;

  @Input() set submitted(value: boolean)
  {
    this._submitted = value; 
  }

  get submitted(): boolean {
    return this._submitted;
  }


  @Output()
  onSubmit: EventEmitter<ICheckoutPersonalInfoForm> = new EventEmitter<ICheckoutPersonalInfoForm>();

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  constructor(private fb: FormBuilder,
              private auth: AuthService,
              private profileService: ProfileService,
              private loader: LoaderService,
              public validators: ValidatorsService) {
      
  }

  ngOnInit() {
    this.getProfile();
    /*  
    this.form = this.fb.group({
      'firstname': ['', this.validators.formBuilderValidationInitializer(true)],
      'lastname': ['', this.validators.formBuilderValidationInitializer(true)],
      'email': ['', this.validators.formBuilderValidationInitializer(true, null, true)],
      //'emailConfirm': ['', this.validators.formBuilderValidationInitializer(true, null, true)],
      'phone': ['', this.validators.formBuilderValidationInitializer(true)]
    });
    */
   this.form = this.fb.group({
      firstname: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true),
        updateOn: 'change'
      }),
      lastname: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true),
        updateOn: 'change'
      }),
      email: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true, null, true),
        updateOn: 'change'
      }),
      // emailConfirm: this.fb.control('', {
      //   validators: this.validators.formBuilderValidationInitializer(true, null, true),
      //   updateOn: 'change'
      // }),
      phone: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true),
        updateOn: 'change'
      })
      // ,{
      //   validators: [
      //     EqualValidator(['email', 'emailConfirm'])
      //   ]
      // }
    });

    /*
    this.form["patternReference"] = {
      firstname: null,
      lastname: null,
      email: null,
      phone: null
    };
    */
    this.patternReference = {
      firstname: null,
      lastname: null,
      email: null,
      phone: null
    };

    //this.validators.trackInputChange(this.form);
    this.validators.trackInputChange(this.form, this.patternReference);

    setInterval(() => {
      this.submit();
    }, 1000);
  }

  async getProfile() {
    if (this.auth.isAuthenticated) {
      const loader = await this.loader.create();
      await loader.present();
      this.profileService.$profile
        .pipe(finalize(async () => {
          await loader.dismiss();
        }))
        .subscribe((profile) => {
          this.profile = profile;
          this.form.get('firstname').setValue(profile.FirstName);
          this.form.get('lastname').setValue(profile.LastName);
          this.form.get('email').setValue(profile.Email);
          //this.form.get('emailConfirm').setValue(profile.Email);
          this.form.get('phone').setValue(profile.Phone);
        });
    }
  }

  submit() {
    //sanitizing  -> disabled sanitizer at the request of anthony
    //this.form.setValue(this.validators.multiSanitizerInput(this.form.value));


    if (!this.form.valid) {
      this.submitEmit(false);
      return;
    }

    this.formErrors.clear();

    this.submitEmit(true);
  }

  formFieldValidatorSubmit(field: string, errorType: string) {
    return this.submitted && this.f[field] && this.f[field].errors && this.f[field].errors[errorType];
  }

  formFieldValidator(field: string, errorType: string) {
    return this.f[field] && this.f[field].errors && this.f[field].errors[errorType];
  }

  submitEmit(valid: boolean) {
    //Revalidate all the field
    let invalid = this.validateAllFormFields(this.form);

    this.onSubmit.emit({
      firstName: this.form.get("firstname").value,
      lastName: this.form.get("lastname").value,
      email: this.form.get("email").value,
      phone: this.form.get("phone").value,
      _valid: !invalid
    });
  }

  validateAllFormFields(formGroup: FormGroup) {
    let keys = Object.keys(formGroup.controls);
    let validateType = ['required', 'email', 'notEquivalent'];
    let invalid = false;
    for(let i = 0; i < keys.length; i++) {
      for (let j = 0; j < validateType.length; j++) {
        invalid = this.formFieldValidator(keys[i], validateType[j]);
        if (invalid) {
         return invalid;
        }
      }     
    }
    return invalid;
  }  
}
